export default __webpack_public_path__ + "4c4bfe66508080144ef97ca92d71b056.png";